export const traHang = {
  sections: {
    list: { title: '退货' },
    detail: { title: '退货单详情' },
    traHang: '退货',
    muaHang: '购买',
  },
  titles: { add: '新建退货单' },
  columns: {
    code: '单号',
    summary: '信息',
    status: '状态',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
  },
  filter: { searchPlaceholder: '按退货单号搜索...' },
  filters: {
    maKhachHang: '客户编码',
    tenKhachHang: '客户名称',
    all: '全部',
    fromDate: '起止日期',
    toDate: '截止日期',
    dateRange: '时间范围',
    dateRangePlaceholder: '选择日期范围',
    status: '状态',
    statusSection: '单据状态',
    dateSection: '退货日期',
    salesSection: '销售',
    peopleSection: '用户',
    seller: '销售员',
    receiverReturn: '退货接收人',
    deliverySection: '配送',
    deliveryPartner: '配送服务商',
    deliveryArea: '配送区域',
    deliveryStatus: '配送状态',
    otherIncomeType: '其他收入类型',
    returnType: '退货类型',
    textDetailTitle: '退货筛选',
    khachHangPlaceholder: '搜索客户',
    hintSection: '提示',
    hintBody: '使用搜索框快速筛选。',
    sortField: '排序字段',
    sortDir: '排序方向',
    sortThoiGian: '时间',
    sortMaPhieu: '退货单号',
    sortCanTraKhach: '应退金额',
    sortTongTienHang: '商品总额',
  },
  form: {
    code: '退货单号',
    codeAuto: '留空自动生成',
    customer: '客户',
    retailCustomer: '散客',
    customerQuickAdd: '快速添加客户',
    channel: '销售渠道',
    returnFee: '退货费',
    note: '备注',
    lines: '退货商品',
    danhSachChiTiet: '明细列表',
    addLine: '添加行',
    product: '商品',
    productName: '商品名称',
    productSearch: '搜索编码 / 名称',
    qty: '数量',
    qtyTra: '退货数量',
    canTruCongNoHint: '发票未付清：{soTien} 将冲抵应收款，不退现金。',
    unitPrice: '单价',
    discount: '折扣',
    discountPercent: '折扣 (%)',
    lineNote: '行备注',
    quickSearch: '搜索退货商品 (F3)',
    quickSearchDoi: '搜索换货商品 (F7)',
    time: '时间',
    customerInfo: '退货信息',
    sourceInvoice: '原始发票',
    sourceInvoiceSearch: '搜索要退货的发票',
    sourceInvoiceEmpty: '未选择发票',
    sourceInvoiceClear: '清除发票',
    returnInfo: '退货详情',
    paymentMethod: '退款方式',
    orderNote: '订单备注',
    refundAmount: '退给客户',
    discountType: '折扣类型',
    discountValue: '折扣值',
    openSourceInvoice: '从发票选择',
    byAmount: '按金额',
    byPercent: '按百分比',
    donViTinh: '单位',
    giaBan: '售价',
    thanhTien: '小计',
    bangGia: '价格表',
    bangGiaDefault: '默认价格',
    creator: '创建人',
    seller: '销售员',
    tabLines: '商品明细',
    maHang: '商品编号',
    discountShort: '折扣',
    salePrice: '售价',
    lineAmount: '金额',
  },
  messages: {
    loadError: '加载失败。',
    deleteSuccess: '已删除。',
    createSuccess: '已创建退货单。',
    updateSuccess: '已更新退货单。',
    needLines: '请至少添加一行商品。',
    noData: '暂无数据。',
    noLines: '没有行。',
    listSummary: '共 {count} 条',
    confirmDelete: '删除单 {name}?',
    cancelSuccess: '已取消退货单。',
    confirmHuy: '取消退货单 {name}？状态将更新为已取消。',
    refundSuccess: '已记录退款。',
    invalidPayAmount: '退款金额无效。',
    refundInlineSuccess: '已创建退货单并记录退款。',
    sourceInvoiceLoaded: '已从发票 {code} 加载 {count} 行。',
    sourceInvoiceNotFound: '未找到发票。',
    sourceInvoiceDaTraHet: '该发票已全部退货 — 没有可退数量。',
    error: '发生错误。',
    phieuXuatKhoFromReturn: '按退货单 {code} 销售出库',
  },
  actions: {
    refund: '退款',
    cancelVoucher: '取消单据',
    pay: '退货',
    clear: '清除',
    detail: '详情',
    ketThuc: '完成',
    xuLyDonHang: '处理订单',
    print: '打印',
    exportFile: '导出文件',
    copy: '复制',
    saoChep: '复制',
    taoPhieuXuatKho: '创建出库单',
    capNhat: '更新',
    dongY: '同意',
    huyBo: '取消',
  },
  fields: {
    totalAmount: '总金额',
    refundedAmount: '已退款',
    refundAmount: '退款金额',
    paymentMethod: '支付方式',
    tongTienHangGoc: '原商品总额',
    tongTienHangTra: '退货商品总额',
    giamGia: '折扣',
    phiTraHang: '退货费',
    hoanTraThuKhac: '其他退款',
    tongTienTra: '退款总额',
    tongTienHang: '商品总额',
    tongTienMua: '购买总额',
    thuKhac: '其他费用',
    giaoHang: '配送',
    canTraKhach: '应退客户',
    khachCanTra: '客户应付',
    khachNhanLai: '已付客户',
    maHoaDonNguon: '来源发票',
    maPhieuNhapKho: '入库单',
    maPhieuXuatKho: '出库单',
    tenKhachHang: '客户',
    khachHang: '客户',
    maPhieuTraHang: '退货单号',
    thoiGian: '退货时间',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    ngayDatHang: '退货时间',
    nguoiTao: '创建人',
    nguoiBan: '销售员',
    nguoiNhanTra: '退货接收人',
    kenhBan: '销售渠道',
    trangThai: '状态',
    chiNhanh: '门店',
    loaiTraHang: '退货类型',
    ghiChu: '备注',
    yeuThich: '收藏',
    actions: '操作',
    maDatHang: '订单编号',
    maHoaDon: '发票编号',
    nguoiNhanDat: '接单人',
    bangGia: '价格表',
    giamGiaHoaDon: '发票折扣',
    phiShip: '运费',
    chiNhanhXuLy: '处理分店',
    chiNhanhTao: '创建分店',
    diaChiLayHang: '取货地址',
    nguoiNhan: '收货人',
    dienThoai: '电话',
    diaChi: '地址',
    khuVuc: '区域',
    phuongXa: '坊/社',
    ghiChuGiaoHang: '配送备注',
    maVanDon: '运单号',
    trongLuong: '重量',
    kichThuoc: '尺寸',
    dichVu: '服务',
    nguoiGiaoDoiTac: '配送员',
    thuHoTienShort: '代收货款',
    phiTraDTGH: '支付配送方费用',
    thoiGianGiaoHang: '配送期限',
    khachDaTra: '客户已付',
  },
  aria: {
    columnPicker: '选择显示列',
  },
  detailTabs: {
    chung: '常规',
    generalInfo: '信息',
    chiTietDonHang: '订单明细',
  },
  status: {
    MOI_TAO: '新建',
    HOAN_THANH: '已完成',
    DA_HUY: '取消',
  },
  loaiTraHang: {
    THEO_HOA_DON: '按发票',
    TRA_NHANH: '快速退货',
    CHUYEN_HOAN: '转退',
  },
  paymentMethod: {
    TIEN_MAT: '现金',
    THE: '银行卡',
    VI: '电子钱包',
    CHUYEN_KHOAN: '转账',
  },
  pos: {
    addTab: '添加退货标签',
    tabTitle: '退货 {n}',
    tabEdit: '编辑 {code}',
    tabClone: '复制 {code}',
    tabFromInvoice: '来源发票 {code}',
    history: '退货历史',
    confirmCloseTitle: '关闭标签?',
    confirmCloseBody: '未保存数据将丢失。是否继续?',
    openEdit: '编辑此单',
    openClone: '创建副本',
    openFromInvoice: '按此发票退货',
    newTabHoaDon: '新发票',
    newTabTraHang: '新退货',
    filterAll: '全部',
    filterHoaDon: '发票',
    filterTraHang: '退货',
    viewFullList: '查看完整列表',
  },
  placeholders: {
    formTitle: '创建/编辑退货',
    formBody: '完整表单将后续补充。',
    ghiChu: '备注...',
    ghiChuGiao: '配送备注...',
    chonDoiTac: '选择合作方...',
  },
  sourceInvoicePicker: {
    title: '选择退货发票',
    searchSection: '搜索',
    maHoaDon: '按发票编号',
    maKhachHang: '按客户编号',
    tenKhachHang: '按客户名称',
    maHang: '按商品编号',
    tenHang: '按商品名称',
    timeSection: '时间',
    timeAll: '全部时间',
    fromDate: '从',
    toDate: '到',
    sellerSection: '销售员',
    sellerPlaceholder: '选择销售员',
    statusSection: '发票状态',
    hint: '仅显示当前分店未取消的发票。',
    choose: '选择',
    noData: '未找到符合条件的发票。',
    summary: '共 {count} 张发票',
    columns: {
      maHoaDon: '发票编号',
      thoiGian: '时间',
      khachHang: '客户',
      nguoiBan: '销售员',
      trangThai: '状态',
      tongTienHang: '商品总额',
      khachCanTra: '客户应付',
      khachDaTra: '客户已付',
    },
  },
  summary: {
    tongTienHangCount: '商品总额（{count}）',
    tongSoLuong: '总数量',
    tongTienHang: '商品总额',
    giamGiaPhieuDat: '折扣',
    tongCong: '合计',
    hangSuaChua: '维修商品',
  },
}
